module.exports = __webpack_public_path__ + "cc094346fdc1ab098c552366e9172367.jpg";